/* TG PDP story (Phase 2, TG-41): UI for sections/tgp-pdp-story.liquid.
   Tabs, pillars, FAQ, flavor picker (accent follows the flavor), supply picker + add to cart,
   and an optional how-to video. No hero animation in this version. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tabs ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tgp-tab]'));
    function pick(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
        if (on && panel) panel.dispatchEvent(new CustomEvent('tgp:shown', { bubbles: true }));
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % tabs.length; else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0; else if (k === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); pick(tabs[j], true); }
      });
    });
  }

  /* ---------- pillars ---------- */
  function initPillars(root) {
    var ps = Array.prototype.slice.call(root.querySelectorAll('[data-tgp-pillar]'));
    var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1100px)');
    function pick(p) {
      if (p.classList.contains('is-active')) return;
      ps.forEach(function (x) { var on = x === p; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    }
    ps.forEach(function (p) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('mouseenter', function () { if (hoverable && hoverable.matches) pick(p); });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    var qs = Array.prototype.slice.call(root.querySelectorAll('[data-tgp-faq]'));
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function (o) {
          var on = o === q && !open, a = document.getElementById(o.getAttribute('aria-controls'));
          o.setAttribute('aria-expanded', on ? 'true' : 'false'); if (a) a.hidden = !on;
        });
      });
    });
  }

  /* ---------- supply picker, flavors, add to cart ---------- */
  function openCart() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        var refresh = (window.Rebuy.Cart && window.Rebuy.Cart.fetchShopifyCart) ? window.Rebuy.Cart.fetchShopifyCart() : Promise.resolve();
        Promise.resolve(refresh).catch(function () {}).then(function () {
          try { window.Rebuy.SmartCart.show(); } catch (e) { window.location.href = '/cart'; }
        });
        return;
      }
    } catch (e) {}
    window.location.href = '/cart';
  }
  function hexRgb(h) {
    var m = /^#?([0-9a-f]{6})$/i.exec(h || ''); if (!m) return null;
    var n = parseInt(m[1], 16); return ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255);
  }
  /* fade the hero product image over to another image */
  function swapHero(hero, src, srcset, alt, animate) {
    if (!hero || !src || hero.getAttribute('src') === src) return;
    var go = function () {
      hero.loading = 'eager'; hero.src = src; if (srcset) hero.srcset = srcset; else hero.removeAttribute('srcset'); if (alt) hero.alt = alt;
      var show = function () { hero.style.opacity = '1'; };
      if (hero.complete) show(); else { hero.addEventListener('load', show, { once: true }); hero.addEventListener('error', show, { once: true }); }
    };
    hero.style.transition = 'opacity .25s ease';
    if (animate) { hero.style.opacity = '0'; setTimeout(go, 200); } else go();
  }

  /* hero follows the size picked in the theme's product form (hero_swap blocks) */
  function initHeroSwap(root) {
    var hero = root.querySelector('.tgp-hero__img'), def = root.querySelector('[data-tgp-hero-default]');
    var swaps = Array.prototype.slice.call(root.querySelectorAll('[data-tgp-hero-swap]'));
    if (!hero || !def || !swaps.length) return null;
    var ids = (def.dataset.variants || '').split(',');
    var onVariant = function (e) {
      var v = e.detail && e.detail.variant; if (!v || (ids.length && ids[0] && ids.indexOf(String(v.id)) < 0)) return;
      var t = String(v.title || v.public_title || (v.options || []).join(' / ')).toLowerCase();
      var hit = swaps.filter(function (s) { return t.indexOf(s.dataset.match) > -1; })[0] || def;
      swapHero(hero, hit.dataset.src, hit.dataset.srcset, hit.dataset.alt, true);
    };
    document.addEventListener('variant:change', onVariant);
    return function () { document.removeEventListener('variant:change', onVariant); };
  }

  function initSS(root) {
    var box = root.querySelector('[data-tgp-ss]'); if (!box) return;
    var btn = box.querySelector('[data-tgp-atc]'), err = box.querySelector('[data-tgp-err]');
    var tiers = Array.prototype.slice.call(box.querySelectorAll('.tgp-tier'));
    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-tgp-flavor]'));
    var photo = root.querySelector('[data-tgp-ss-img]');
    var hero = root.querySelector('.tgp-hero__img');
    var current = null;

    function syncButton() {
      if (!btn) return;
      var input = box.querySelector('.tgp-tier__input:checked');
      var lab = input ? input.closest('.tgp-tier') : null;
      var ok = lab && !lab.classList.contains('is-soldout') && lab.dataset.variant;
      btn.disabled = !ok;
      btn.textContent = ok ? (btn.dataset.label || 'Add to Cart') : 'Sold out';
    }

    function setFlavor(name) {
      var f = flavors.filter(function (x) { return x.dataset.name === name; })[0];
      if (!f) return;
      var prev = current; current = name;
      flavors.forEach(function (x) { x.setAttribute('aria-checked', x === f ? 'true' : 'false'); x.tabIndex = x === f ? 0 : -1; });
      var d = f.dataset;
      if (d.accent) {
        root.style.setProperty('--tgp-accent', d.accent);
        var rgb = hexRgb(d.accent); if (rgb) root.style.setProperty('--tgp-acc-rgb', rgb);
      }
      if (d.ink) root.style.setProperty('--tgp-acc-ink', d.ink);
      if (d.on) root.style.setProperty('--tgp-on-acc', d.on);
      if (d.num) root.style.setProperty('--tgp-num', d.num);
      if (hero && d.hero) swapHero(hero, d.hero, d.heroSrcset, d.heroAlt, !!(prev && prev !== name)); // hero box follows the flavor
      if (photo && d.img) { photo.src = d.img; if (d.imgSrcset) photo.srcset = d.imgSrcset; else photo.removeAttribute('srcset'); }
      var label = box.querySelector('[data-tgp-flavor-name]'); if (label) label.textContent = name;
      tiers.forEach(function (t) {
        var map = {}; try { map = JSON.parse(t.dataset.variants || '{}'); } catch (e) {}
        var v = map[name];
        t.dataset.variant = v && v[0] ? v[0] : '';
        t.classList.toggle('is-soldout', !v || !v[1]);
      });
      syncButton();
    }

    flavors.forEach(function (f, i) {
      f.addEventListener('click', function () { setFlavor(f.dataset.name); });
      f.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % flavors.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + flavors.length) % flavors.length;
        if (j > -1) { e.preventDefault(); setFlavor(flavors[j].dataset.name); flavors[j].focus(); }
      });
    });
    /* purchase-type toggle (Subscribe / One-time) and the perks list under the size cards */
    var modes = Array.prototype.slice.call(box.querySelectorAll('[data-tgp-mode]'));
    var groups = Array.prototype.slice.call(box.querySelectorAll('[data-tgp-group]'));
    var perks = box.querySelector('[data-tgp-perks]');
    function checkedLabel() { var i = box.querySelector('.tgp-tier__input:checked'); return i ? i.closest('.tgp-tier') : null; }
    // pack shot follows the picked size (e.g. the refill pouch for pouch sizes)
    var ssDef = root.querySelector('[data-tgp-ss-default]'), ssSwap = root.querySelector('[data-tgp-ss-swap]'), photoReady = false;
    function syncPhoto(lab) {
      if (!photo || !ssDef || !ssSwap || !lab) return;
      var sub = lab.querySelector('.tgp-tier__sub');
      var txt = ((lab.dataset.card || '') + ' ' + (sub ? sub.textContent : '')).toLowerCase();
      var hit = txt.indexOf(ssSwap.dataset.match) > -1 ? ssSwap : ssDef;
      swapHero(photo, hit.dataset.src, hit.dataset.srcset, hit.dataset.alt, photoReady);
      photoReady = true;
    }
    function syncMode() {
      var lab = checkedLabel(), kind = lab ? lab.dataset.kind : '';
      syncPhoto(lab);
      groups.forEach(function (g) { g.hidden = g.dataset.tgpGroup !== kind; });
      modes.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.tgpMode === kind ? 'true' : 'false'); });
      if (perks) { var d = lab ? lab.querySelector('.tgp-tier__detail') : null; perks.innerHTML = d ? d.innerHTML : ''; }
    }
    function pickMode(kind) {
      var cur = checkedLabel();
      if (cur && cur.dataset.kind === kind) return;
      var pool = tiers.filter(function (t) { return t.dataset.kind === kind; });
      if (!pool.length) return;
      var next = pool.filter(function (t) { return cur && t.dataset.card === cur.dataset.card; })[0] ||
                 pool.filter(function (t) { return t.hasAttribute('data-default'); })[0] || pool[pool.length - 1];
      var inp = next.querySelector('.tgp-tier__input');
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    modes.forEach(function (b, i) {
      b.addEventListener('click', function () { pickMode(b.dataset.tgpMode); });
      b.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % modes.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + modes.length) % modes.length;
        if (j > -1) { e.preventDefault(); pickMode(modes[j].dataset.tgpMode); modes[j].focus(); }
      });
    });
    tiers.forEach(function (t) {
      var input = t.querySelector('.tgp-tier__input');
      if (input) input.addEventListener('change', function () { syncButton(); syncMode(); });
    });
    syncMode();

    if (flavors.length) {
      // start on the flavor in ?variant= when it matches one, else the section default
      var start = box.dataset.defaultFlavor, vid = new URLSearchParams(window.location.search).get('variant');
      if (vid) {
        tiers.some(function (t) {
          var map = {}; try { map = JSON.parse(t.dataset.variants || '{}'); } catch (e) {}
          return Object.keys(map).some(function (k) { if (String(map[k][0]) === vid) { start = k; return true; } return false; });
        });
      }
      setFlavor(start || flavors[0].dataset.name);
      // follow the flavor picked in the theme's main product form at the top of the page
      var byId = {};
      tiers.forEach(function (t) {
        var map = {}; try { map = JSON.parse(t.dataset.variants || '{}'); } catch (e) {}
        Object.keys(map).forEach(function (k) { if (map[k] && map[k][0]) byId[String(map[k][0])] = k; });
      });
      var onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var name = byId[String(v.id)];
        if (!name) { var opts = v.options || [v.option1, v.option2, v.option3]; name = (opts || []).filter(function (o) { return flavors.some(function (x) { return x.dataset.name === o; }); })[0]; }
        if (name && name !== current) setFlavor(name);
      };
      document.addEventListener('variant:change', onVariant);
      root._tgpOff = function () { document.removeEventListener('variant:change', onVariant); };
    } else syncButton();

    if (!btn) return;
    btn.dataset.label = btn.textContent;
    btn.addEventListener('click', function () {
      var input = box.querySelector('.tgp-tier__input:checked');
      var lab = input ? input.closest('.tgp-tier') : null;
      if (!lab || !lab.dataset.variant || lab.classList.contains('is-soldout')) return;
      var item = { id: parseInt(lab.dataset.variant, 10), quantity: 1 };
      var plan = parseInt(lab.dataset.plan, 10); if (plan) item.selling_plan = plan;
      var label = btn.dataset.label;
      btn.disabled = true; btn.textContent = 'Adding...'; if (err) err.hidden = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { btn.disabled = false; btn.textContent = label; openCart(); })
        .catch(function () { btn.disabled = false; btn.textContent = label; if (err) err.hidden = false; });
    });
  }

  /* ---------- optional how-to video: plays while on screen ---------- */
  function initVideo(root) {
    var v = root.querySelector('[data-tgp-video]'); if (!v) return null;
    v.muted = true;
    if (reduceMotion) { v.setAttribute('controls', ''); v.preload = 'metadata'; return null; }
    if (!('IntersectionObserver' in window)) { v.preload = 'auto'; v.play().catch(function () {}); return null; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (v.preload !== 'auto') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    io.observe(v);
    return io;
  }

  /* ---------- number count-up ---------- */
  /* TG PDP motion: numbers count up when they come into view, and again when a live number changes. Oct 9, 2026 */
  function tgFx(scope, sel) {
    var doc = scope.ownerDocument || scope;
    var win = doc.defaultView || window;
    var api = { count: function () {}, stop: function () {} };
    if (win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches) return api;
    var clamp = function (x) { return Math.max(0, Math.min(1, x)); };
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    var cleanup = [];
    var run = function (el, txt) {
      if (!txt) txt = el._tgRaf ? el._tgFinal : el.textContent; /* a re-trigger mid-count keeps the real target */
    el._tgFinal = txt;
      var m = txt.match(/^(\D*)([\d,]*\.?\d+)(.*)$/);
      if (el._tgRaf) { win.cancelAnimationFrame(el._tgRaf); el._tgRaf = 0; }
      if (!m) { el.textContent = txt; return; }
      var pre = m[1], raw = m[2], post = m[3], commas = raw.indexOf(',') > -1;
      var val = parseFloat(raw.replace(/,/g, '')), dec = (raw.split('.')[1] || '').length;
      var fmt = function (v) { var s = v.toFixed(dec); if (commas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return pre + s + post; };
      el.style.fontVariantNumeric = 'tabular-nums';
      var t0 = 0;
      var tick = function (now) { if (!t0) t0 = now; var p = clamp((now - t0) / 1300); el.textContent = p < 1 ? fmt(val * ease(p)) : txt; el._tgRaf = p < 1 ? win.requestAnimationFrame(tick) : 0; };
      el.textContent = fmt(0);
      el._tgRaf = win.requestAnimationFrame(tick);
    };
    api.count = function (el) { run(el); };
    var watch = function (el, onSeen) {
      if (!('IntersectionObserver' in win)) { onSeen(); return; }
      var io = new win.IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); onSeen(); } }); }, { threshold: 0.5 });
      io.observe(el); cleanup.push(function () { io.disconnect(); });
    };
    Array.prototype.slice.call(scope.querySelectorAll(sel.nums || '[data-none]')).forEach(function (el) {
      watch(el, function () { run(el); });
    });
    /* live numbers: a hidden source the page keeps current, and a visible copy we animate */
    if (sel.live) {
      Array.prototype.slice.call(scope.querySelectorAll(sel.live)).forEach(function (src) {
        var out = src.parentElement && src.parentElement.querySelector('[data-tg-out]');
        if (!out) return;
        var seen = false;
        watch(out, function () { seen = true; run(out, src.textContent); });
        if ('MutationObserver' in win) {
          var mo = new win.MutationObserver(function () { if (seen) run(out, src.textContent); else out.textContent = src.textContent; });
          mo.observe(src, { childList: true, characterData: true, subtree: true });
          cleanup.push(function () { mo.disconnect(); });
        }
      });
    }
    api.stop = function () { cleanup.forEach(function (f) { f(); }); };
    return api;
  }

  /* ---------- theme sticky "Add to cart" bar: send shoppers to Subscribe & Save ---------- */
  function initStickyBar(root) {
    var ss = root.querySelector('#supply'); if (!ss) return null;
    var chip = ss.querySelector('.tgp-seg__chip');
    var label = chip ? 'Subscribe & ' + chip.textContent.trim().toLowerCase() : 'Choose your supply';
    var bars = function () { return Array.prototype.slice.call(document.querySelectorAll('product-quick-add')); };
    var relabel = function () {
      bars().forEach(function (bar) {
        Array.prototype.forEach.call(bar.querySelectorAll('button[type="submit"]'), function (b) {
          var t = b.querySelector('div') || b;
          if (t.textContent !== label) t.textContent = label;
          b.setAttribute('aria-label', label);
        });
      });
    };
    var onClick = function (e) {
      var b = e.target.closest && e.target.closest('product-quick-add button[type="submit"]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      ss.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };
    document.addEventListener('click', onClick, true);
    relabel();
    var mo = new MutationObserver(relabel);
    bars().forEach(function (bar) { if (bar.parentElement) mo.observe(bar.parentElement, { childList: true, subtree: true, characterData: true }); });
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { document.documentElement.classList.toggle('tgp-ss-in-view', e.isIntersecting); }); }, { threshold: 0.15 });
      io.observe(ss);
    }
    return function () { document.removeEventListener('click', onClick, true); mo.disconnect(); if (io) io.disconnect(); document.documentElement.classList.remove('tgp-ss-in-view'); };
  }

  /* ---------- boot ---------- */
  var instances = new Map();
  function init(root) {
    if (!root || instances.has(root)) return;
    initTabs(root); initPillars(root); initFaq(root); initSS(root);
    var fx = tgFx(root, { nums: '.tgp-hero__big, .tgp-ingpanel__num' });
    root.addEventListener('tgp:shown', function (e) { var n = e.target.querySelector && e.target.querySelector('.tgp-ingpanel__num'); if (n) fx.count(n); });
    instances.set(root, { vio: initVideo(root), fx: fx, bar: initStickyBar(root), hs: initHeroSwap(root) });
  }
  function destroy(root) {
    var inst = instances.get(root); if (!inst) return;
    if (inst.vio) inst.vio.disconnect();
    if (inst.fx) inst.fx.stop();
    if (inst.bar) inst.bar();
    if (inst.hs) inst.hs();
    if (root._tgpOff) root._tgpOff();
    instances.delete(root);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-tgp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-tgp]'); if (r) init(r); });
  document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('[data-tgp]'); if (r) destroy(r); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b.matches && b.matches('[data-tgp-tab],[data-tgp-pillar],[data-tgp-flavor]')) b.click();
    else if (b.querySelector) { var q = b.querySelector('[data-tgp-faq][aria-expanded="false"]'); if (q) q.click(); }
  });
})();
